import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_TextHighlights = _resolveComponent("TextHighlights")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_infinite_scroll = _resolveComponent("v-infinite-scroll")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.internalVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.internalVisible) = $event)),
    "max-width": "900px",
    "onClick:outside": _ctx.close
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('lieferant.tvskundenliste.list.title')), 1),
              _createVNode(_component_v_btn, {
                icon: "",
                onClick: _ctx.close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("mdi-close")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.filterData.suchText,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterData.suchText) = $event)),
                  _ctx.searchFieldInputChanged
                ],
                "prepend-inner-icon": "mdi-magnify",
                label: _ctx.$t('suche'),
                "hide-details": "",
                variant: "outlined",
                density: "comfortable",
                class: "mb-4"
              }, null, 8, ["modelValue", "label", "onUpdate:modelValue"]),
              _createVNode(_component_v_infinite_scroll, {
                ref: "infiniteScroll",
                onLoad: _ctx.load
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table_server, {
                    "sort-by": _ctx.sortBy,
                    "onUpdate:sortBy": [
                      _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sortBy) = $event)),
                      _ctx.onSortByChanged
                    ],
                    headers: _ctx.headers,
                    items: _ctx.tvsKundenListe,
                    loading: _ctx.loading,
                    "items-length": _ctx.totalNumberOfRecords || 0,
                    "must-sort": true,
                    "item-value": "tvsKundennummer",
                    hover: "",
                    "hide-default-footer": "",
                    class: "elevation-1 nowhow-table",
                    "onClick:row": _ctx.onRowClicked
                  }, {
                    "item.tvsKundennummer": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.tvsKundennummer,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.name": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.name,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.vorname": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.vorname,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.firma": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.firma,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.plz": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.plz,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.ort": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.ort,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    _: 1
                  }, 8, ["sort-by", "headers", "items", "loading", "items-length", "onUpdate:sortBy", "onClick:row"])
                ]),
                _: 1
              }, 8, ["onLoad"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "onClick:outside"]))
}